// removed by extract-text-webpack-plugin
module.exports = {"formLabel":"formLabel___1b4em","formLabelLarge":"formLabelLarge___wmDP0","formBoldLabel":"formBoldLabel___3Ybmp"};


//////////////////
// WEBPACK FOOTER
// ./src/components/HookFormInputs/FormLabel.module.less
// module id = 3737
// module chunks = 31